import { Link } from "react-router-dom";
import { ArrowRight, Mail, Phone } from "lucide-react";
import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";
import site from "@/data/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

function PageHeader() {
  return (
    <section className="relative bg-bloom overflow-hidden">
      <div className="container-luxe relative py-20 lg:py-28 text-center">
        <Reveal>
          <span className="eyebrow">FAQs</span>
          <h1 className="display-xl font-display mt-4">
            Answers,
            <span className="block font-script italic text-rose-ink leading-[1.05] mt-1">With Care.</span>
          </h1>
          <p className="mt-6 text-lg text-muted-ink max-w-2xl mx-auto leading-relaxed">
            A few things families often want to know before reaching out.
          </p>
        </Reveal>
      </div>
    </section>
  );
}

function Faqs() {
  return (
    <section className="section bg-ivory">
      <div className="container-luxe max-w-3xl">
        <Reveal>
          <Accordion type="single" collapsible defaultValue="item-0" className="space-y-4">
            {site.faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-white border border-line rounded-2xl px-6 data-[state=open]:border-rose data-[state=open]:shadow-[0_20px_50px_-25px_rgba(201,122,136,0.4)] transition-all duration-500"
              >
                <AccordionTrigger className="font-display text-xl md:text-2xl text-left hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-ink text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}

function ContactBand() {
  return (
    <section className="section bg-soft-blush">
      <div className="container-luxe">
        <Reveal>
          <div className="rounded-[2rem] p-10 md:p-14 bg-white border border-line grid md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-7">
              <span className="eyebrow">Still wondering?</span>
              <h2 className="display-md font-display mt-3">We'd love to hear from you.</h2>
              <p className="mt-3 text-muted-ink">Reach out directly for pricing, availability, and personalized arrangements.</p>
            </div>
            <div className="md:col-span-5 flex flex-col gap-3">
              <a href={site.phoneHref} className="btn-pill btn-primary justify-center" data-testid="faq-call">
                <Phone className="w-4 h-4" /> {site.phone}
              </a>
              <a href={site.emailHref} className="btn-pill btn-ghost justify-center" data-testid="faq-email">
                <Mail className="w-4 h-4" /> {site.email}
              </a>
              <Link to="/contact" className="btn-pill btn-ivory justify-center" data-testid="faq-contact-page">
                Contact Form <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default function Faq() {
  return (
    <>
      <Seo
        title="FAQ | Eternal Care Pink Hearse Houston"
        description="Common questions about Eternal Care's pink hearse funeral transportation, service areas, personalization, custom requests, and more."
        path="/faq"
      />
      <PageHeader />
      <Faqs />
      <ContactBand />
    </>
  );
}
